<div class="search-btn" (click)="openSearchPanel(true,searchModal)">
  <img class="{{imgSize}}" [src]="assetsPath + '/svg/search-glass-white.svg'" />
  <span *ngIf="label">{{label}}</span>
</div>

<!-- <ng-template #content let-modal> -->
<ng-container
  *ngIf="isPanelOpen && (windowSize === 'tablet' || windowSize === 'mobile')"
>
  <ng-content *ngTemplateOutlet="searchModal"></ng-content>
</ng-container>

<ng-template #searchModal>
  <div
    class="search-modal-body"
    [ngClass]="
      windowSize === 'tablet' || windowSize === 'mobile' ? ' tablet' : 'desktop'
    "
  >
    <div *ngIf="windowSize === 'tablet' || windowSize === 'mobile'" class="row cancel-row">
      <div class="cancel-holder" (click)="closePanel()">
        <img src="../../../assets/svg/cancel-icon.svg">
      </div>
    </div>
    <div class="search-container">
      <app-poshvine-input-box
        [type]="'text'"
        [placeholder]="'Search for brands or merchants'"
        [imageSrcRight]="'../../../assets/svg/search-glass.svg'"
        [isImageEnabled]="true"
        [imageSrcLeft]="'../../../assets/images/forward-arrow.png'"
        [isNavButton]="true"
        (formModelInputChange)="brandSearchEventHandler($event)"
        (leftButtonClickEvent)="closePanel()"
      ></app-poshvine-input-box>
      <div *ngIf="searchTerm" class="merchants-list-container">
        <ng-container *ngIf="listOfMerchants && listOfMerchants.length && !isSearchLoading">
          <div
            *ngFor="let merchant of listOfMerchants"
            class="merchants-list-item"
            (click)="navigateToOfferDetails(merchant)"
          >
            <div>{{ merchant?.name }}</div>
            <span>in {{ merchant?.searchType }} </span>
          </div>
        </ng-container>
        <ng-container *ngIf="listOfMerchants && !listOfMerchants.length && !isSearchLoading">
          <div class="merchants-list-item">
            <!-- <div>{{ merchant?.name }}</div> -->
            <span class="no-merchant"
              >
              No Merchant or brand found
            </span>
          </div>
        </ng-container>
        <ng-container *ngIf="listOfMerchants && !listOfMerchants.length && isSearchLoading">
          <div class="merchants-list-item loading"
          *ngFor="let merchant of [1,2,3]">
            <!-- <div>{{ merchant?.name }}</div> -->
            <span class="no-merchant"
              >
              <app-poshvine-skeleton-loader [component]="'plain-square'"></app-poshvine-skeleton-loader>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="topCategories?.length && !catsLoading" class="category-container brk d-flex flex-column">
      <span class="category-title">Popular Categories</span>
      <div class="category-labels d-flex">
          <app-poshvine-label-fab *ngFor="let elem of topCategories"
          [labelTitle]="elem?.attributes?.name"
          [isSvg]="false"
          [isGeneric]="true"
          [avatarPath]="elem?.attributes?.logo_url"
          (click)="selectTopItem('cat',elem)"
        ></app-poshvine-label-fab>
      </div>
    </div>
    <div *ngIf="!topCategories?.length && catsLoading" class="category-container brk d-flex flex-column">
      <span class="category-title"></span>
      <div class="category-labels d-flex">
          <app-poshvine-label-fab *ngFor="let elem of [1,2,3,4,5]"
          [isLoading]="true"
        ></app-poshvine-label-fab>
      </div>
    </div>
    <div *ngIf="topBrands?.length && !brandsLoading" class="category-container d-flex flex-column">
      <span class="category-title">Top Brands</span>
      <div class="category-labels d-flex">
          <app-poshvine-label-fab *ngFor="let elem of topBrands"
          [labelTitle]="elem?.attributes?.name"
          [isSvg]="false"
          [avatarPath]="elem?.attributes?.logo_url"
          (click)="selectTopItem('brand',elem)"
        ></app-poshvine-label-fab>
      </div>
    </div>
    <div *ngIf="!topBrands?.length && brandsLoading" class="category-container d-flex flex-column">
      <span class="category-title"></span>
      <div class="category-labels d-flex">
          <app-poshvine-label-fab *ngFor="let elem of [1,2,3,4]"
          [isLoading]="true"
        ></app-poshvine-label-fab>
      </div>
    </div>
  </div>
</ng-template>

<!-- </ng-template> -->
